import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";

export var filterByPlAndAttrField = function filterByPlAndAttrField(
attrs,
filterByField,
productLine)
{
  // show only the attributes that have filterByField attribute === true and same product line id
  return _filterInstanceProperty(attrs).call(attrs, function (attr) {return attr[filterByField] && attr.productLine === productLine;});
};
//# sourceMappingURL=utils.js.map